var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.7867 14.7584L11.6544 10.6261C12.5511 9.50607 13.0908 8.08864 13.0908 6.54538C13.0908 2.93669 10.1541 0 6.54538 0C2.93669 0 0 2.93669 0 6.54538C0 10.1541 2.93669 13.0908 6.54538 13.0908C8.08864 13.0908 9.50607 12.5511 10.6261 11.6544L14.7584 15.7867C14.9002 15.9285 15.0864 15.9998 15.2726 15.9998C15.4587 15.9998 15.6449 15.9285 15.7867 15.7867C16.0711 15.5024 16.0711 15.0427 15.7867 14.7584ZM6.54538 11.6362C3.73814 11.6362 1.45453 9.35262 1.45453 6.54538C1.45453 3.73814 3.73814 1.45453 6.54538 1.45453C9.35262 1.45453 11.6362 3.73814 11.6362 6.54538C11.6362 9.35262 9.35262 11.6362 6.54538 11.6362Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.d3c0a274.svg";
export { ForwardRef as ReactComponent };